import React from "react";
import PropTypes from "prop-types";
import { PrimaryButton } from "@fluentui/react";

const functionalityButtonStyles = {
  root: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: "2.5vh",
    gap: "8px",
    width: "78vw",
    height: "36px",
    backgroundColor: "#E8ECF4",
    border: "1px solid #CED4E2",
    borderRadius: "4px",
    flex: "none",
    order: 1,
    flexGrow: 0,
    color: "#1F2430",
    fontWeight: 400,
    fontFamily: "Poppins",
  },
  rootHovered: {
    backgroundColor: "#18468F",
  },
  textContainer: {
    fontFamily: "Poppins",
    lineHeight: "20px",
    fontSize: "3vh",
    fontWeight: 400,
  },
  label: {
    fontWeight: 400,
    fontSize: "4.5vw",
  },
};

export default function FunctionalityButton(props) {
  function getTextColor() {
    if (props.buttonText === "Accept All Changes") {
      return "white";
    } else if (props.buttonText === "Reject All Changes") {
      return "black";
    } else if (props.hovered === props.buttonText || (props.selected === props.buttonText && props.hovered === "")) {
      return "white";
    } else {
      return "black";
    }
  }

  function getBorderColor() {
    if (props.buttonText === "Accept All Changes" || props.buttonText === "Reject All Changes") {
      return "1px solid #F6EAE7";
    } else {
      return "1px solid #CED4E2";
    }
  }

  function getBackgroundColor() {
    if (props.bgColor) {
      return props.bgColor;
    } else if (props.hovered === props.buttonText || (props.selected === props.buttonText && props.hovered === "")) {
      return "#18468F";
    } else {
      return "#E8ECF4";
    }
  }
  return (
    <PrimaryButton
      styles={functionalityButtonStyles}
      onClick={props.onClickFunction}
      disabled={props.buttonText === "Prepare for Signature"}
      style={{
        color: getTextColor(),
        border: getBorderColor(),
        backgroundColor: getBackgroundColor(),
        transition: "background-color 0.2s ease, color 0.2s ease",
      }}
      onMouseEnter={() => {
        props.setHovered(props.buttonText);
      }}
      onMouseLeave={() => {
        props.setHovered("");
      }}
    >
      {props.buttonText}
    </PrimaryButton>
  );
}

FunctionalityButton.propTypes = {
  color: PropTypes.string,
  onClickFunction: PropTypes.func,
  buttonText: PropTypes.string,
  id: PropTypes.string,
  selected: PropTypes.string,
};
